/** Show list/detail callback hint only while next follow-up still matches the automated callback time. */
export function isActiveCustomerCallbackAt(
  customerCallbackAt: string | null | undefined,
  nextFollowUpAt: string | null | undefined
): boolean {
  if (!customerCallbackAt) return false;
  if (!nextFollowUpAt) return true;

  const callbackMs = new Date(customerCallbackAt).getTime();
  const followUpMs = new Date(nextFollowUpAt).getTime();
  if (Number.isNaN(callbackMs) || Number.isNaN(followUpMs)) {
    return true;
  }

  return Math.abs(callbackMs - followUpMs) <= 60_000;
}
